import { Toaster } from 'sonner';
import { Providers } from './providers/Providers';
import { AppRouter } from './router/Router';
import { ErrorDialog } from '@/shared/components/ahkinia/ErrorDialog/ErrorDialog';
import { GlobalLoader } from '@/shared/components/ahkinia/GlobalLoader/GlobalLoader';

function App() {
  return (
    <Providers>
      <AppRouter />
      <Toaster position="top-right" richColors closeButton />
      <ErrorDialog />
      <GlobalLoader />
    </Providers>
  );
}

export default App;
